import React from 'react';
import { useSirenActionSubmitter, useSirenEntity, useStoreValues } from '~/utility/BinSentry-ui-utility';
import { Button, makeStyles, Tooltip } from '~/lib/bn-material-ui';
import { useOrderFasIntegrationState } from '~/orders/integrations/fas/use-fas-integration-state';
import OrderIntegrationIcon from '~/orders/integrations/order-integration-icon';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'inline-flex',
    flexDirection: 'row',
    gap: '0.5rem',
    alignItems: 'center',
  },
  retry: {
    textDecoration: 'underline',
    marginLeft: '1rem',
  },
  message: {
    fontStyle: 'italic',
    textOverflow: 'ellipsis',
    color: theme.palette.green[20],
  },
  'not-synced': {
    color: theme.palette.gray[60],
  },
  error: {
    color: theme.palette.red[20],
  },
}));

export function FasOrderState({ orderHref, showCreateMobileOrder = true }) {
  const styles = useStyles();
  const { isProducer } = useStoreValues(['isProducer']);
  const { state, message, loading, fasIntegrationsEntity } = useOrderFasIntegrationState({ orderId: orderHref, isActionable: showCreateMobileOrder }) || {};
  if (loading || isProducer) {
    return null;
  }

  const messageClassnames = [styles[state], styles.message].filter(Boolean).join(' ');
  return (
    <div className={styles.container}>
      <OrderIntegrationIcon loading={loading} state={state} size='normal'/>
      <span className={messageClassnames}>{message.split('\n').map(((line, i) =>
        <div key={i}>{line}</div>
      ))}</span>
      {showCreateMobileOrder && fasIntegrationsEntity && <CreateNewMobileOrderButton fasIntegrationsEntity={fasIntegrationsEntity} />}
    </div>
  );
}

function CreateNewMobileOrderButton({ fasIntegrationsEntity }) {
  const { entity: orderEntity } = useSirenEntity({ href: fasIntegrationsEntity.getLinkByRel('https://api.binsentry.com/rel/order').href });
  const sirenAction = fasIntegrationsEntity.getAction('create-mobile-fas-order');
  const alreadyHasMobileOrder = !!fasIntegrationsEntity.properties.mobileEventReferenceNumbers?.length;
  const { submit, submitting } = useSirenActionSubmitter({ sirenAction });
  if (!sirenAction || !orderEntity || orderEntity.properties.state !== 'scheduled') {
    return null;
  }
  return (
    <Tooltip title='Create new mobile order in FAS'>
      <Button
        onClick={ async () => {
          if (alreadyHasMobileOrder && !window.confirm('FAS already has a mobile order for this order. Are you sure you want to create a new one?')) {
            return;
          }
          await submit();
        }}
        disabled={ submitting }
      >
        Create New Mobile Order
      </Button>
    </Tooltip>
  );
}
